import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import supabase from "../supabaseClient.js";

const dateDevice = new Date();
const year = dateDevice.getFullYear();
const month = dateDevice.getMonth() + 1;
const day = dateDevice.getDate();
const formattedMonth = month.toString().padStart(2, "0");
const formattedDay = day.toString().padStart(2, "0");
const clientDate = `${year}-${formattedMonth}-${formattedDay}`;

export const incrementGamesPlayedAsync = createAsyncThunk(
  "gamesPlayed/increment_gamesplayed",
  async () => {
    const dateDevice = new Date();
    const year = dateDevice.getFullYear();
    const month = dateDevice.getMonth() + 1;
    const day = dateDevice.getDate();
    const formattedMonth = month.toString().padStart(2, "0");
    const formattedDay = day.toString().padStart(2, "0");
    let clientDate = `${year}-${formattedMonth}-${formattedDay}`;

    let { data, error } = await supabase
      .rpc("Increment_floridaman_gamesplayed", { _target_date: clientDate })
      .then((response) => {
        if (response.error) {
          console.error("Error:", response.error);
        } else {
        }
      });
  }
);

export const incrementSharesAsync = createAsyncThunk(
  "saveShares/saveShares",
  async (date) => {
    const dateDevice = new Date();
    const year = dateDevice.getFullYear();
    const month = dateDevice.getMonth() + 1;
    const day = dateDevice.getDate();
    const formattedMonth = month.toString().padStart(2, "0");
    const formattedDay = day.toString().padStart(2, "0");
    let clientDate = `${year}-${formattedMonth}-${formattedDay}`;

    let { data, error } = await supabase
      .rpc("shared_floridaman", { _target_date: clientDate })
      .then((response) => {
        if (response.error) {
          console.error("Error:", response.error);
        } else {
        }
      });
  }
);

export const fetchCompleteFloridaManDailyProblemCreationAsync =
  createAsyncThunk(
    "percents/completeFloridaManDailyProblemCreation",
    async () => {
      try {
        let { data, error } = await supabase
          .from("floridaManDaily")
          .select("*")
          .eq("created_at", clientDate);

        if (data.length === 0) {
          const daily3 = await supabase
            .from("FloridaMen")
            .select("*", { count: "exact", head: true })
            .then(async (data) => {
              const { count } = data;

              let { data: previouslyincluded, error } = await supabase
                .from("floridaManDaily")
                .select("previouslyincluded")
                .order("id", { ascending: false })
                .limit(1);

              const previousIds = JSON.parse(
                previouslyincluded[0].previouslyincluded
              );

              if (previousIds.length >= 10) {
                previousIds.splice(0, 3);
              }

              const countArr = [];
              for (let i = 1; i <= count; i++) {
                countArr.push(i);
              }
              const remainingInArr = countArr.filter((e) =>
                previousIds.every((element) => element !== e)
              );

              const randomArr = [];
              const maxNumber = Math.max(...remainingInArr);
              for (let i = 0; randomArr.length < 3; i++) {
                let randomNumber = Math.floor(
                  Math.random() * (Math.max(maxNumber) - 1) + 1
                );

                const exists = randomArr.includes(randomNumber);
                if (remainingInArr.includes(randomNumber) && !exists)
                  randomArr.push(randomNumber);
              }

              return {
                randomArr: randomArr,
                previousIds: previousIds,
              };
            })
            .then(async (idsAndPreviousIds) => {
              const { randomArr, previousIds } = idsAndPreviousIds;

              const { data, error } = await supabase
                .from("FloridaMen")
                .select()
                .in("id", randomArr);

              const completePrevious = previousIds.concat(randomArr);

              const completeData = {
                daily3: data,
                previouslyincluded: completePrevious,
              };
              return completeData;
            })
            .then(async (completeData) => {
              const { data, error } = await supabase
                .from("floridaManDaily")
                .insert([
                  {
                    created_at: clientDate,
                    daily3: completeData.daily3,
                    previouslyincluded: completeData.previouslyincluded,
                  },
                ])
                .select();

              return completeData.daily3;
            });
          return daily3;
        } else {
          return data[0].daily3;
        }
      } catch (error) {
        console.error(error);
        alert(error.message);
        throw error;
      }
    }
  );

export const gameSlice = createSlice({
  name: "game",
  initialState: { daily: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchCompleteFloridaManDailyProblemCreationAsync.fulfilled,
      (state, action) => {
        if (typeof action.payload === "string") {
          const parseString = JSON.parse(action.payload);

          const newArr = parseString.map((e) => e);

          state.daily = newArr;
        } else {
          const array = [];
          action.payload.map((e) => array.push(e));
          state.daily = array;
        }
      }
    );
  },
});

export const {} = gameSlice.actions;

export default gameSlice.reducer;
